import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { TaskResponseDto } from '@nx-frontend/shared/types';
import { MoveNotePayload } from '@nx-frontend/shared/types';

export async function moveNote({
  noteServiceUrl,
  userId,
  workspaceFrom,
  noteFrom,
  workspaceId,
  remove,
  parentId,
  titleSuffix,
  duplicating,
  taskId,
  cnt,
  notIncludePortalShare,
}: MoveNotePayload): Promise<TaskResponseDto | null> {
  const host = noteServiceUrl ?? generalEnv.noteServiceUrl;
  const response = await axiosClient.post<TaskResponseDto>(
    `${host}/v1/workspaces/${workspaceFrom}/notes/${noteFrom}/workspaceTask`,
    {
      workspaceId,
      remove,
      parentId,
      titleSuffix,
      duplicating,
      taskId,
      cnt,
      notIncludePortalShare,
    },
    {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    }
  );
  return response.data;
}
